export default function ({ redirect }) {
  return redirect('/maintenance')
}
